import React from "react";
import {withTranslate} from "react-redux-multilingual";
import SectionHeader from "./SectionHeader";

const WorkProcess = ({translate}) => {

    return (
        <section className="working-process-area">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 center">
                    <SectionHeader header={translate("work_process_header")} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="working-process">
                            <ul className="clearfix">
                                <li className="arrow  wow fadeInDown" data-wow-delay="300ms">
                                    <div className="single-item">
                                        <div className="icon-holder" style={{padding: "20px 0 15px !important"}}>
                                            <img src="/images/search.png" className="loon-icon" alt="ste-icon "/>
                                            <div className="count-box">
                                                <h4>1</h4>
                                            </div>
                                        </div>
                                        <div className="text-holder  shadow-4d rounded-corners">

                                            <h3 className="capitalized">{translate("wp_search_for_doctor")}</h3>
                                            <p>{translate("wp_search_for_doctor_desc")}</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="arrow top martop50 wow fadeInDown" data-wow-delay="300ms">
                                    <div className="single-item">
                                        <div className="icon-holder">
                                            <img src="/images/appointment.png" className="loon-icon" alt="ste-icon "/>
                                            <div className="count-box">
                                                <h4>2</h4>
                                            </div>
                                        </div>
                                        <div className="text-holder  shadow-4d rounded-corners">
                                            <h3 className="capitalized">{translate("wp_book_appointment")}</h3>
                                            <p>{translate("wp_book_appointment_desc")}</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="arrow  wow fadeInDown" data-wow-delay="300ms">


                                    <div className="single-item">
                                        <div className="icon-holder">
                                            <img src="/images/track.png" className="loon-icon" alt="ste-icon "/>
                                            <div className="count-box">
                                                <h4>3</h4>
                                            </div>
                                        </div>
                                        <div className="text-holder  shadow-4d rounded-corners">


                                            <h3 className="capitalized">{translate("wp_track_visit")}</h3>
                                            <p>{translate("wp_track_visit_desc")}</p>
                                        </div>
                                    </div>
                                </li>
                                <li className=" top martop50 wow fadeInDown" data-wow-delay="300ms">


                                    <div className="single-item">
                                        <div className="icon-holder">
                                            <img src="/images/offer.png" className="loon-icon" alt="ste-icon "/>
                                            <div className="count-box">
                                                <h4>4</h4>
                                            </div>
                                        </div>
                                        <div className="text-holder  shadow-4d rounded-corners">
                                            <h3 className="capitalized">{translate("wp_cash_back")}</h3>
                                            <p>{translate("wp_cash_back_desc")}</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};


export default withTranslate(WorkProcess);


